let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("gOuNw")).then(() => parcelRequire('lu6uO'));